import { api } from './customers'

export interface CustomerLog {
    id: number
    customerId: number
    medium: string
    status: string
    comments: string
}

type CustomerLogsResponse = CustomerLog[]


export const CustomerLogApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCustomerLogs: build.query<CustomerLogsResponse, void>({
            query: () => 'customer_logs',
            providesTags: (result) =>
                result
                    ? [
                        ...result["data"]?.map(({ id }) => ({ type: 'CustomerLog' as const, id })),
                        { type: 'CustomerLog', id: 'LIST' },
                    ]
                    : [{ type: 'CustomerLog', id: 'LIST' }],
        }),
        addCustomerLog: build.mutation<CustomerLog, Partial<CustomerLog>>({
            query: (body) => ({
                url: `customer_logs`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: CustomerLog }, meta, arg) => response.data,
        }),
        getCustomerLog: build.query<CustomerLog, string>({
            query: (id) => `customer_logs/${id}`,
            transformResponse: (response: { data: CustomerLog }, meta, arg) => response.data,
        }),
        getCustomerLogByCustomerId: build.query<CustomerLog[], string>({
            query: (id) => `get_customer_logsBycustomerID/${id}`,
            transformResponse: (response: { data: CustomerLog[] }, meta, arg) => response.data,
        }),
        updateCustomerLog: build.mutation<void, Pick<CustomerLog, 'id'> & Partial<CustomerLog>>({
            query: ({ id, ...patch }) => ({
                url: `customer_logs/${id}`,
                method: 'PUT',
                body: patch,
            }),
        }),
        deleteCustomerLog: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `customer_logs/${id}`,
                    method: 'DELETE',
                }
            },
        }),
    }),
})

export const {
    useGetCustomerLogQuery,
    useGetCustomerLogsQuery,
    useGetCustomerLogByCustomerIdQuery,
    useAddCustomerLogMutation,
    useUpdateCustomerLogMutation,
    useDeleteCustomerLogMutation,
} = CustomerLogApi

